import { render, staticRenderFns } from "./MaterialTypeList.vue?vue&type=template&id=1860edae&scoped=true"
import script from "./MaterialTypeList.vue?vue&type=script&lang=js"
export * from "./MaterialTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1860edae",
  null
  
)

export default component.exports